import { getDeliveryLocation } from './deliveryLocation';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bodegon_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if ((!config.method || config.method === 'get') && /^\/(products(?:\/[^/]+)?|wishlist)$/.test(config.url)) {
    const point = getDeliveryLocation();
    if (point) config.params = { ...config.params, latitude: point.latitude, longitude: point.longitude };
  }
  return config;
});

export default api;
